<template>
  <div class="px-4">
    <ul class="nav nav-list my-4">
      <li
        v-for="item in dynamicNavItems"
        :key="item.title"
        class="nav-item mx-2 font-weight-bold"
      >
        <router-link
          class="nav-link p-0"
          active-class="sub-active"
          :to="item.to"
        >
          {{ item.title }}
          <span
            class="count"
            id="saved-jobs-count"
            v-if="
              item.title == 'Saved Jobs' &&
              $store.state.userProfile.savedJobs.length
            "
          >
            {{ savedJobsTotal }}
          </span>
          <span
            class="count"
            id="activity-count"
            v-if="item.title == 'Activity'"
          ></span>
          <div
            v-if="
              (item.title == 'View Job Briefings' &&
                hasJobBriefingNotification) ||
              (item.title == 'Post a Project' && hasProjectNotification) ||
              (item.title == 'Post a Job' && hasJobApplicationNotification)
            "
            style="float: right; position: relative; top: -5px"
          >
            <svg
              width="13"
              height="12"
              viewBox="0 0 13 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle
                cx="6.97656"
                cy="6"
                r="5"
                fill="#FA0000"
                stroke="white"
                stroke-width="2"
              />
            </svg>
          </div>
        </router-link>
      </li>
    </ul>
    <router-view></router-view>
  </div>
</template>

<script>
import { hasProjectNotification as hasProjectNotificationHelper } from "@/utils/notifications"
export default {
  name: "inner-layout",
  props: {
    navItems: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      savedJobs: [],
      savedJobsTotal: 0,
      isToolbox: false,
      dynamicNavItems: [],
      hasJobBriefingNotification:
        this.$store.state.userProfile.type == "jobSeeker" &&
        this.$store.state.userProfile.profilesRequested.findIndex(
          (x) =>
            x.type == "job" && x.profile != this.$store.state.userProfile._id
        ) > -1,
      hasJobApplicationNotification:
        this.$store.state.userProfile.type == "provider" &&
        this.$store.state.userProfile.profilesRequested.findIndex(
          (x) => x.type == "job-application"
        ) > -1,
    }
  },
  computed: {
    hasProjectNotification() {
      const projects = this.$store.state.projects?.list || []
      const profilesRequested =
        this.$store.state.userProfile?.profilesRequested || []
      return hasProjectNotificationHelper(projects, profilesRequested)
    },
  },
  methods: {
    async fetchSavedJobs() {
      const profileId = this.$store.state.userProfile?._id

      const data = await this.$store.dispatch("api/getSavedJobs", {
        limit: 100,
        page: 1,
        profileId,
      })

      this.savedJobs = data.data.result
      this.savedJobsTotal = data.data.total
    },
  },
  created() {
    if (this.$store.state.userProfile.type == "jobSeeker") {
      this.fetchSavedJobs()
    }
  },
  watch: {
    $route: {
      handler(route) {
        this.isToolbox = route.path.includes("toolbox")
        this.isJobView = route.path.includes("employees/jobs-view")
        let isProfileOrJobView =
          (route.path.includes("toolbox") &&
            route.path.includes("update-profile")) ||
          route.path.includes("employees/jobs-view")
        this.dynamicNavItems =
          !this.isToolbox && !this.isJobView
            ? this.navItems
            : isProfileOrJobView
            ? []
            : this.$store.state.userProfile.type === "jobSeeker"
            ? this.navItems.filter(
                (x) =>
                  x.title === "Connections" ||
                  x.title === "Notification Settings"
              )
            : this.navItems
      },
      immediate: true,
    },
  },
}
</script>

<style lang="scss" scoped>
.nav-list {
  &:has(li) {
    border-bottom: 1px solid var(--Gray-200, #d5d9e2) !important;
  }

  li {
    margin-right: 48px !important;

    a {
      color: #525f7f;
      font-weight: 600;
    }

    a.active {
      .count {
        background: var(--gfb-blue-brand-500, #0095e2);
      }
    }

    .count {
      display: flex;
      max-width: 24px;
      padding: 0px 18px;
      justify-content: center;
      align-items: center;
      border-radius: 100px;
      background: var(--Gray-500, #677690);
      color: var(--White, #fff);
      font-size: 14px;
      font-style: normal;
      font-weight: 600;
      position: relative;
      top: 2px;
      float: right;
      margin-left: 8px;
    }
    .sub-active {
      border-bottom: 2px solid var(--gfb-blue-brand-500, #0095e2) !important;
      color: #0095e2;
    }
  }

  @media (max-width: 768px) {
    li {
      width: 100%;
      text-align: center;
      margin-right: 0px !important;
      margin-left: 0px !important;

      .sub-active {
        background: #c8ecff;
        border-bottom: none !important;
      }

      .nav-link {
        padding-top: 16px !important;
        width: 100%;
        text-align: center;
        border-bottom: 1px solid rgb(0, 0, 0, 0.125);

        &.active {
          border-bottom: none !important;
        }
      }

      &:last-of-type {
        .nav-link {
          border-bottom: none !important;
        }
      }

      .count {
        right: 20px;
      }
    }
  }
}

@media (max-width: 480px) {
  .my-4 {
    margin-bottom: 0px !important;
  }
}
</style>
